import { EventEmitter } from "events";

const eventBus = new EventEmitter();

export  {eventBus};